/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

export default {
	name: "date-picker",
	props: ["format", "elementId", "date", "initialiseDate", "startDate", "endDate", "disabled"],
	emits: ["dateChange"],
	data() {
		return {
			selectElementId: "select",
			selectedValue: null,
			dateValue: null
		};
	},
	methods: {
		onDateChange() {
            this.$emit("dateChange", this.dateValue);
		}
	},
	mounted: function () {
        
        
	},
	watch: {
		// elementId: {
		// 	handler: function () {
		//		
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		date:{
			handler: function () {
				console.log("date", this.date)
				if(this.date){
					this.dateValue = this.date;
				}
				else{
					this.dateValue = null;
				}
			},
			immediate: true,
			deep: true
		},
		// endDate:{
		//
		// }
	},
	unmounted: function () {
		console.log("unmounted");
	}
};
